import Validator from 'validatorjs';
// @ts-expect-error - validatorjs' global state requires some magic. See comment below
import en from 'validatorjs/src/lang/en';
// It is not possible to dynamically require language files when a package that has validatorjs as a dependency
// is compiled using rollup. Validatorjs does this internally.
// When this package is used in conjunction with a rollup compiled package, due to the global nature of
// a lot of features within validatorjs, this fails!
// Loading 'en' here, as it is the default language. This is also referenced internally
// for some methods that are not directly related to validation errors.
Validator.setMessages('en', en || { def: 'The :attribute attribute has errors.', attributes: {} });
// https://docs.microsoft.com/en-us/office/troubleshoot/excel/determine-a-leap-year
function leapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}
function checkFalsePositiveDates(dateString = '') {
    if (dateString.length === 10) {
        // massage input to use yyyy-mm-dd format
        // we support yyyy/mm/dd or yyyy.mm.dd
        let normalizedDate = dateString.replace('.', '-').replace('/', '-');
        let parts = normalizedDate.split('-');
        if (parts.length === 3) {
            if (parts[0].length === 4) {
                // yyyy-mm-dd format
                let y = parseInt(parts[0]);
                let m = parseInt(parts[1]);
                let d = parseInt(parts[2]);
                if (m === 2) {
                    // return leapYear(y) ? d <= 29 : d <= 28;
                    if (leapYear(y)) {
                        if (d > 29) {
                            return false;
                        }
                    }
                    else {
                        if (d > 28) {
                            return false;
                        }
                    }
                }
                if (m === 4 || m === 6 || m === 9 || m === 11) {
                    if (d > 30) {
                        return false;
                    }
                }
            }
        }
        return true; // we are not in february, proceed
    }
    return true; // we are not testing formatted date, proceed to rest of validation
}
function isValidDate(dateString) {
    let testDate;
    if (typeof dateString === 'number') {
        testDate = new Date(dateString);
        if (typeof testDate === 'object') {
            return true;
        }
        else {
            dateString = `${dateString}`;
        }
    }
    else if (typeof dateString === 'boolean') {
        return false;
    }
    // first convert incoming string to date object and see if it corrects date and format
    testDate = new Date(dateString);
    if (typeof testDate === 'object') {
        if (testDate.toString() === 'Invalid Date') {
            return false;
        }
        /**
         * Check for false positive dates
         * perform special check on february as JS `new Date` incorrectly returns valid date
         * E.g.  let newDate = new Date('2020-02-29')  // returns as March 02, 2020.
         * E.g.  let newDate = new Date('2019-02-29')  // returns as March 01, 2020.
         * E.g.  let newDate = new Date('2019-04-31')  // returns as April 30, 2020.
         */
        if (!checkFalsePositiveDates(dateString)) {
            return false;
        }
        // valid date object and not a february date
        return true;
    }
    // First check for the pattern
    const regex_date = /^\d{4}-\d{1,2}-\d{1,2}$/;
    if (!regex_date.test(dateString)) {
        return false;
    }
    // Parse the date parts to integers
    const parts = dateString.split('-');
    const day = parseInt(parts[2], 10);
    const month = parseInt(parts[1], 10);
    const year = parseInt(parts[0], 10);
    // Check the ranges of month and year
    if (year < 1000 || year > 3000 || month == 0 || month > 12) {
        return false;
    }
    const monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    // Adjust for leap years
    if (year % 400 == 0 || (year % 100 != 0 && year % 4 == 0)) {
        monthLength[1] = 29;
    }
    // Check the range of the day
    return day > 0 && day <= monthLength[month - 1];
}
function after(val, req) {
    let val1 = req;
    if (!isValidDate(val)) {
        return false;
    }
    if (!isValidDate(val1)) {
        val1 = this.validator.input[val1];
        if (!isValidDate(val1)) {
            return false;
        }
    }
    return new Date(val1).getTime() < new Date(val).getTime();
}
function after_or_equal(val, req) {
    let val1 = req;
    if (!isValidDate(val)) {
        return false;
    }
    if (!isValidDate(val1)) {
        val1 = this.validator.input[val1];
        if (!isValidDate(val1)) {
            return false;
        }
    }
    return new Date(val1).getTime() <= new Date(val).getTime();
}
function before(val, req) {
    let val1 = req;
    if (!isValidDate(val)) {
        return false;
    }
    if (!isValidDate(val1)) {
        val1 = this.validator.input[val1];
        if (!isValidDate(val1)) {
            return false;
        }
    }
    return new Date(val1).getTime() > new Date(val).getTime();
}
function before_or_equal(val, req) {
    let val1 = req;
    if (!isValidDate(val)) {
        return false;
    }
    if (!isValidDate(val1)) {
        val1 = this.validator.input[val1];
        if (!isValidDate(val1)) {
            return false;
        }
    }
    return new Date(val1).getTime() >= new Date(val).getTime();
}
const messages = Validator.getMessages(Validator.getDefaultLang());
Validator.register('after', after, messages && typeof messages['after'] === 'string' ? messages['after'] : undefined);
Validator.register('after_or_equal', after_or_equal, messages && typeof messages['after_or_equal'] === 'string' ? messages['after_or_equal'] : undefined);
Validator.register('before', before, messages && typeof messages['before'] === 'string' ? messages['before'] : undefined);
Validator.register('before_or_equal', before_or_equal, messages && typeof messages['before_or_equal'] === 'string' ? messages['before_or_equal'] : undefined);
export default Validator;
//# sourceMappingURL=validator.js.map